import React from "react";
import style from "./AuthPrompt.module.css";
import Icon from "@/ui/icon/Icon";
import { Link } from "react-router-dom";
import { useLoginWithGoogle } from "../../hooks/useLoginWithGoogle";

function AuthPrompt({ popup }) {
	const { loginWithGoogle } = useLoginWithGoogle();

	return (
		<div className={`${style.container} ${popup ? style.popup : ""}`}>
			<div className={style.header}>
				<h2>Registrujte se</h2>
				<p>
					Škola, ali na <span>lakši način.</span>
				</p>
			</div>

			<div className={style.methods}>
				<div onClick={loginWithGoogle} className={style.method}>
					<div className={style.icoHolder}>
						<Icon icon="fa-google" iconType="fa-brands" />
					</div>
					<span>Registrujte se putem Google-a</span>
				</div>
				<Link to="/register" className={style.method}>
					<div className={style.icoHolder}>
						<Icon icon="fa-envelope" iconType="fa-solid" />
					</div>
					<span>Registrujte se putem email-a</span>
				</Link>
			</div>
			<div className={style.divider}>
				<div className={style.line}></div>
				<span>ili</span>
				<div className={style.line}></div>
			</div>
			<div className={style.login}>
				<p>Već imate nalog?</p>
				<Link className={style.method} to="/login">
					<div className={style.icoHolder}>
						<Icon icon="fa-user" />
					</div>
					<span>Prijavite se</span>
				</Link>
			</div>
		</div>
	);
}

export default AuthPrompt;
